export default {
  password: {
    presence: { allowEmpty: false },
    length: {
      maximum: 128
    }
  }
};
